import { render, staticRenderFns } from "./campaign-sms-template-settings.vue?vue&type=template&id=5a7ebb38&"
import script from "./campaign-sms-template-settings.vue?vue&type=script&setup=true&lang=js&"
export * from "./campaign-sms-template-settings.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports